import {
	call,
	fork,
	put,
	takeLatest,
	takeEvery,
	select,
} from 'redux-saga/effects';
import { get } from 'lodash';

import { INIT_APP_ERROR } from '@/redux/ducks/init/types';
import kycStatusSelector from '@/online-merchant-onboarding/redux/ducks/kyc/selectors';
import { SHOW_TOAST } from '@/redux/ducks/toast/types';
import { merchantOnboardingStageSelector } from '@/online-merchant-onboarding/redux/ducks/onboarding/selectors';
import {
	CATEGORY_LIST_ERROR,
	CATEGORY_LIST_REQUESTING,
	CATEGORY_LIST_SUCCESS,
	KYC_INIT_ERROR,
	KYC_INIT_REQUESTED,
	KYC_STATUS_ERROR,
	KYC_STATUS_REQUESTED,
	KYC_STATUS_SUCCESS,
	PINCODE_DETAILS_ERROR,
	PINCODE_DETAILS_REQUESTING,
	PINCODE_DETAILS_SUCCESS,
	SUB_CATEGORY_LIST_ERROR,
	SUB_CATEGORY_LIST_REQUESTING,
	SUB_CATEGORY_LIST_SUCCESS,
	SUPER_CATEGORY_LIST_ERROR,
	SUPER_CATEGORY_LIST_REQUESTING,
	SUPER_CATEGORY_LIST_SUCCESS,
	UPDATE_MERCHANT_DETAILS,
	UPDATE_MERCHANT_DETAILS_ERROR,
	UPDATE_MERCHANT_DETAILS_SUCCESS,
} from '@/online-merchant-onboarding/redux/ducks/kyc/types';
import ApiService from '@/online-merchant-onboarding/services/ApiService';
import GlobalConstants from '@/online-merchant-onboarding/utils/globalConstant';
import {
	getMerchantId,
	transformKycStatusData,
} from '@/online-merchant-onboarding/utils/utils';
import { Toast } from '@/widgets';
import textConstant from '@/constants/textConstant';

const { SOMETHING_WENT_WRONG } = textConstant;

export function* handleGetSuperCategoryList() {
	try {
		const response = yield call(ApiService.getBusinessSuperCategoryList);
		const categories = response.data;
		yield put({ type: SUPER_CATEGORY_LIST_SUCCESS, data: categories });
	} catch (error) {
		if (error.status === 401) {
			yield put({ type: INIT_APP_ERROR, error: error.data });
		} else {
			yield put({ type: SUPER_CATEGORY_LIST_ERROR, error: error.data });
		}

		yield put({
			type: SHOW_TOAST,
			payload: {
				msg: get(error, 'data.message'),
				type: 'error',
			},
		});
	}
}

export function* getSuperCategoryListWatcher() {
	yield takeLatest(SUPER_CATEGORY_LIST_REQUESTING, handleGetSuperCategoryList);
}

export function* handleGetPincodeDetails(params) {
	try {
		const response = yield call(ApiService.getPincodeDetails, params.payload);
		yield put({ type: PINCODE_DETAILS_SUCCESS, data: response.data });
	} catch (error) {
		if (error.status === 401) {
			yield put({ type: INIT_APP_ERROR, error: error.data });
		} else {
			yield put({ type: PINCODE_DETAILS_ERROR, error: error.data });
		}
	}
}

export function* getPincodeDetailsWatcher() {
	yield takeLatest(PINCODE_DETAILS_REQUESTING, handleGetPincodeDetails);
}

export function* handleUpdateMerchantDetails(params) {
	try {
		const response = yield call(
			ApiService.updateMerchantDetails,
			params.payload.data,
		);
		// yield call(kycInit, params.payload);
		// yield put({ type: KYC_INIT_REQUESTED, data: params.payload });
		yield put({ type: UPDATE_MERCHANT_DETAILS_SUCCESS, data: response.data });
	} catch (error) {
		if (error.status === 401) {
			yield put({ type: INIT_APP_ERROR, error: error.data });
		} else {
			Toast.error(get(error, 'data.message', SOMETHING_WENT_WRONG));
			yield put({ type: UPDATE_MERCHANT_DETAILS_ERROR, error: error.data });
		}
	}
}
export function* updateMerchantDetailsWatcher() {
	yield takeEvery(UPDATE_MERCHANT_DETAILS, handleUpdateMerchantDetails);
}

export function* kycInitHandler(params) {
	try {
		const initResponse = yield call(ApiService.kycInit, {
			merchantId: params.payload.merchantId,
			type: GlobalConstants.KYC_INIT_MERCHANT_TYPE
				.ONLINE_MERCHANT_ONBOARDING_VERIFICATION,
			appVersion: GlobalConstants.KYC_INIT_VERSION,
		});
		params.payload.startKyc(initResponse.data.data.accessToken);
		yield call(kycStatusHandler);
	} catch (error) {
		if (error.status === 401) {
			yield put({ type: INIT_APP_ERROR, error: error.data });
		} else {
			yield put({ type: KYC_INIT_ERROR, error: error.data });
		}

		yield put({
			type: SHOW_TOAST,
			payload: {
				msg: get(error, 'data.message'),
				type: 'error',
			},
		});
	}
}

export function* kycInitWatcher() {
	yield takeEvery(KYC_INIT_REQUESTED, kycInitHandler);
}

export function* kycStatusHandler() {
	try {
		// Getting merchantId from localstorage
		const merchantId = getMerchantId();
		if (merchantId) {
			const kycStatusRes = yield call(ApiService.getKycStatus, {
				merchantId,
				profileType:
					GlobalConstants.KYC_INIT_MERCHANT_TYPE
						.ONLINE_MERCHANT_ONBOARDING_VERIFICATION,
			});
			const kycStatusState = yield select(kycStatusSelector);
			const onboardingStage = yield select(merchantOnboardingStageSelector);
			const transformedKycStatus = transformKycStatusData(
				kycStatusRes.data.data,
				kycStatusState,
				onboardingStage,
			);
			yield put({ type: KYC_STATUS_SUCCESS, data: transformedKycStatus });
		} else {
			yield put({ type: KYC_STATUS_ERROR, error: 'NO_MID' });
		}
	} catch (error) {
		if (error.status === 401) {
			yield put({ type: INIT_APP_ERROR, error: error.data });
		} else {
			yield put({ type: KYC_STATUS_ERROR, error: error.data });
		}

		yield put({
			type: SHOW_TOAST,
			payload: {
				msg: get(error, 'data.message'),
				type: 'error',
			},
		});
	}
}

export function* kycStatusWatcher() {
	yield takeEvery(KYC_STATUS_REQUESTED, kycStatusHandler);
}

export function* handleGetCategoryList(data) {
	try {
		const response = yield call(
			ApiService.getBusinessCategoryList,
			data.payload,
		);
		const categories = response.data;
		yield put({ type: CATEGORY_LIST_SUCCESS, data: categories });
	} catch (error) {
		if (error.status === 401) {
			yield put({ type: INIT_APP_ERROR, error: error.data });
		} else {
			yield put({ type: CATEGORY_LIST_ERROR, error: error.data });
		}
	}
}
export function* getCategoryListWatcher() {
	yield takeLatest(CATEGORY_LIST_REQUESTING, handleGetCategoryList);
}

export function* handleGetSubCategoryList(data) {
	try {
		const response = yield call(
			ApiService.getBusinessCategoryList,
			data.payload,
		);
		const categories = response.data;
		yield put({ type: SUB_CATEGORY_LIST_SUCCESS, data: categories });
	} catch (error) {
		if (error.status === 401) {
			yield put({ type: INIT_APP_ERROR, error: error.data });
		} else {
			yield put({ type: SUB_CATEGORY_LIST_ERROR, error: error.data });
		}
	}
}
export function* getSubCategoryListWatcher() {
	yield takeLatest(SUB_CATEGORY_LIST_REQUESTING, handleGetSubCategoryList);
}
function* kycFlowSaga() {
	yield fork(getSuperCategoryListWatcher);
	yield fork(getCategoryListWatcher);
	yield fork(getSubCategoryListWatcher);
	yield fork(getPincodeDetailsWatcher);
	yield fork(updateMerchantDetailsWatcher);
	yield fork(kycInitWatcher);
	yield fork(kycStatusWatcher);
}
export default kycFlowSaga;
